/*=========================================================================================
  File Name: state.js
  Namespace: collections
  Description: Vuex Store - Collection state
==========================================================================================*/

const COLLECTION_POSSIBLE_STATUS = {
  DRAFT: 'draft',
  COMMING_SOON: 'coming soon',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
  UNPUBLISHED: 'unpublished',
}

export const COLLECTION_POSSIBLE_DIFFICULTY = {
  INFORMATIVE: 'informative',
  NOVICE: 'novice',
  PROFESSIONAL: 'professional',
  ADVANCED: 'advanced',
  EXPERT: 'expert',
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

export const buildCollectionState = () => {
  return {
    id: null,
    name: '',
    slug: '',
    url: '',
    description: '',
    content: [],
    instructors: [],
    difficulty: null,
    learning_areas: [],
    categories: [],
    vendor: null,
    tags: [],
    status: COLLECTION_POSSIBLE_STATUS.DRAFT,
    published_date: null,
    created: null, // date of creation
    modified: null, // last modification date
    images: {
      main_image_url: '',
    },
    related_collections: null,
    is_featured: false,
    access: {
      related_passes: [],
      user_passes: [],
      has_access: null,
    },
    direct_passes: [],
  }
}
const state = {
  currentCollection: buildCollectionState(),
  collectionList: null,
  results: [],
  next: null,
  previous: null,
  count: 0,
  COLLECTION_POSSIBLE_STATUS: COLLECTION_POSSIBLE_STATUS,
  COLLECTION_POSSIBLE_DIFFICULTY: COLLECTION_POSSIBLE_DIFFICULTY,
  collectionStatusTransitions: {
    [COLLECTION_POSSIBLE_STATUS.DRAFT]: [
      COLLECTION_POSSIBLE_STATUS.DRAFT,
      COLLECTION_POSSIBLE_STATUS.COMMING_SOON,
      COLLECTION_POSSIBLE_STATUS.PUBLISHED,
    ],
    [COLLECTION_POSSIBLE_STATUS.COMMING_SOON]: [
      COLLECTION_POSSIBLE_STATUS.COMMING_SOON,
      COLLECTION_POSSIBLE_STATUS.DRAFT,
      COLLECTION_POSSIBLE_STATUS.PUBLISHED,
    ],
    [COLLECTION_POSSIBLE_STATUS.PUBLISHED]: [
      COLLECTION_POSSIBLE_STATUS.PUBLISHED,
      COLLECTION_POSSIBLE_STATUS.ARCHIVED,
      COLLECTION_POSSIBLE_STATUS.UNPUBLISHED,
    ],
    [COLLECTION_POSSIBLE_STATUS.ARCHIVED]: [
      COLLECTION_POSSIBLE_STATUS.ARCHIVED,
      COLLECTION_POSSIBLE_STATUS.PUBLISHED,
      COLLECTION_POSSIBLE_STATUS.UNPUBLISHED,
    ],
    [COLLECTION_POSSIBLE_STATUS.UNPUBLISHED]: [
      COLLECTION_POSSIBLE_STATUS.UNPUBLISHED,
      COLLECTION_POSSIBLE_STATUS.PUBLISHED,
    ],
  },
  hundredCollections: null,
  collectionsCsv: [],
}

export default state
